import { BFF_BASE_URL } from 'modules/api/const';
import { IPoolUploadAuth } from 'modules/api/methods/signPoolUploadAuth';

interface IPinResponse {
  IpfsHash: string;
}

function authHeaders(auth: IPoolUploadAuth): Record<string, string> {
  return {
    'X-Pool-Address': auth.poolAddress,
    'X-Timestamp': String(auth.timestamp),
    'X-Signature': auth.signature,
  };
}

async function parsePinResponse(res: Response): Promise<IPinResponse> {
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`Pinata upload failed (${res.status}): ${text}`);
  }
  return res.json();
}

/** Uploads a file to Pinata through the BFF gateway (JWT stays server-side). */
export async function pinFileViaBff(
  file: File,
  auth: IPoolUploadAuth,
): Promise<IPinResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(`${BFF_BASE_URL}/pinata/pin-file`, {
    method: 'POST',
    headers: authHeaders(auth),
    body: formData,
  });

  return parsePinResponse(res);
}

/** Uploads a JSON object to Pinata through the BFF gateway. */
export async function pinJsonViaBff(
  json: unknown,
  auth: IPoolUploadAuth,
): Promise<IPinResponse> {
  const res = await fetch(`${BFF_BASE_URL}/pinata/pin-json`, {
    method: 'POST',
    headers: {
      ...authHeaders(auth),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pinataContent: json }),
  });

  return parsePinResponse(res);
}
